import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewShort } from "../../utils/backend";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { formatDateTime } from "../../components/FormattedTime/FormatDateTime";

const ViewShort = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [short, setShort] = useState({});
  const [shortUrl, setShortUrl] = useState("");
  const { id } = useParams();

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const fetchData = async (id) => {
    setIsLoading(true);
    try {
      const response = await viewShort({ id: id });
      setShort(response.data);
      setShortUrl(
        `${process.env.REACT_APP_API_URL}/uploads/${response.data.file_name}`
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setShort({});
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate("/shorts");
  };

  const hasPermission = (permissionGroup, permissionName) => {
    let permissions;
    try {
      permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      permissions = [];
    }

    return permissions.some(
      (perm) =>
        perm.permission_group === permissionGroup &&
        perm.permission_name === permissionName
    );
  };

  const ShortDetails = ({ data }) => {
    const renderValue = (value, key) => {
      if (
        value &&
        typeof value === "string" &&
        /^\d{4}-\d{2}-\d{2}/.test(value) &&
        !isNaN(Date.parse(value))
      ) {
        return formatDateTime(value)
      }

      if (typeof value === "string" && key === "file_name") {
        const fullUrl = `${process.env.REACT_APP_API_URL}/uploads/${value}`;

        return (
          <a
            href={fullUrl}
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 hover:text-blue-800 underline"
            onClick={(e) => {
              e.preventDefault();
              window.open(fullUrl, "_blank");
            }}
          >
            {value.split("/").pop()}
          </a>
        );
      }

      if (typeof value === "object" && value !== null) {
        return (
          <ul>
            {Object.entries(value).map(([key, val]) => (
              <li key={key}>
                <strong>{key.replace(/_/g, " ")}:</strong> {renderValue(val)}
              </li>
            ))}
          </ul>
        );
      }
      return value ? value.toString() : "N/A";
    };

    return (
      <div className="row">
        {short &&
          Object.keys(short).map((key) => (
            <div className="col-md-4 mb-3" key={key}>
              <label className="form-label">{key.replace(/_/g, " ")}:</label>
              <p>
                <b>{renderValue(short[key], key)}</b>
              </p>
            </div>
          ))}
      </div>
    );
  };

  return (
    <>
      {isLoading ? (
        <div className="card border-light">
          <div className="card-body p-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Skeleton
                height={40}
                width={100}
                style={{ marginRight: "10px" }}
              />
              <Skeleton height={40} width={100} />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div
            className="card border-light"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <div
              className="card-body p-4"
              style={{ flex: 1 }}
            >
              {short.file_name?.endsWith(".mov") ? (
                <video
                  controls
                  style={{ aspectRatio: "9:16", height: "100%", border: "2px dashed #808080", padding:"5px", minHeight:"500px" }}
                  src={shortUrl}
                  title={short.title || "N/A"}
                >
                  Your browser does not support the video tag.
                </video>
              ) : (
                <iframe
                  className=""
                  style={{ aspectRatio: "9:16", height: "100%", border: "2px dashed #808080", padding:"5px", minHeight:"500px" }}
                  src={shortUrl}
                  title={short.title || "N/A"}
                ></iframe>
              )}
            </div>

            <div
              className="card-body p-4"
              style={{
                flex: 4,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div className="row">
                <ShortDetails data={short} />
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn me-3 ansa-button-secondary"
                  onClick={handleBackClick}
                >
                  Back
                </button>
                {hasPermission("Short Management", "Edit") && (
                  <button
                    type="button"
                    className="btn ansa-button-primary"
                    onClick={() => navigate(`/shorts/details/${id}/edit`)}
                  >
                    Edit
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ViewShort;
